<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">
              {{ `${isEdit ? "Edit" : "New"} BuildingTag` }}
            </h4>
            <v-form ref="buildingTagForm" @submit.prevent="save()">
              <v-row>
                <v-col md="12">
                  <v-text-field
                    v-model="buildingTagModel.description"
                    label="BuildingTag Name"
                    required
                    outlined
                    :rules="[(v) => !!v || 'BuildingTag Name is required']"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-btn type="submit" color="success">Save</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import { BuildingTag } from "@/models/BuildingTag";
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      buildingTagModel: new BuildingTag(),
      me: "",
      search: null,
    };
  },
  created() {
    this.isEdit = this.$route.params.id != 0;
    this.isLoading = this.isEdit ? true : false;
  },
  computed: {
    crumbs() {
      return [
        {
          text: "BuildingTags",
          disabled: false,
          href: "/admin/buildingTags",
        },
        {
          text: "BuildingTag Detail",
          disabled: false,
          href: `/admin/buildingTag/${this.$route.params.id}`,
        },
        {
          text: `${this.isEdit ? "Edit" : "New"} BuildingTag`,
          disabled: true,
        },
      ];
    },
  },
  watch: {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    buildingTag: {
      query: gql`
        query BuildingTag($id: ID!) {
          buildingTag(id: $id) {
            id
            description
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.isEdit;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      result(response, key) {
        this.isLoading = false;
        this.buildingTagModel.id = this.buildingTag.id;
        this.buildingTagModel.description = this.buildingTag.description;
      },
    },
  },
  methods: {
    async save() {
      this.isLoading = true;
      const self = this;
      if (!self.$refs.buildingTagForm.validate()) {
        self.$swal("Error", "Validation failed", "error");
        self.isLoading = false;
        return;
      }
      if (self.isEdit) {
        // update
        await this.updateBuildingTag()
          .then(() => {
            this.$swal("Success!", "BuildingTag was updated", "success");
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              "something went wrong when trying to update the buildingTag, check data and try again later!",
              "error"
            );
          });
      } else {
        // create
        await this.createBuildingTag()
          .then(() => {
            this.$swal("Success!", "Building Tag was created", "success");
            window.location.href = `/admin/buildingTags`;
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              `Something went wrong when creating the buildingTag, check data and try again later!`,
              "error"
            );
          });
      }
      this.isLoading = false;
    },
    async updateBuildingTag() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation update($buildingTag: BuildingTagUpdateInput!) {
              updateBuildingTag(buildingTag: $buildingTag) {
                id
                updated
              }
            }
          `,
          variables: {
            buildingTag: {
              id: self.buildingTagModel.id,
              description: self.buildingTagModel.description,
              createdBy: self.me.id,
            },
          },
        });
        if (!response) {
          throw "Something went wrong when creating the buildingTag!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
      } catch (e) {
        throw e.message;
      }
    },
    async createBuildingTag() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createBuildingTag($buildingTag: BuildingTagCreateInput!) {
              createBuildingTag(buildingTag: $buildingTag) {
                id
              }
            }
          `,
          variables: {
            buildingTag: {
              description: self.buildingTagModel.description,
              createdBy: self.me.id,
            },
          },
        });

        if (!response) {
          throw "Something went wrong when creating the BuildingTag Item!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
        if (response && response.data.createBuildingTag) {
          self.buildingTagModel.id = response?.data?.createBuildingTag?.id;
        }
      } catch (e) {
        throw e.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
